(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miscella-blooms-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miscella-blooms-gallery')) {
    customElements.define('miscella-blooms-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        this.controls = this.querySelector('[data-gallery-controls]');
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        if (!this.track || !this.controls) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previousButton.addEventListener('click', () => this.move(-1), options);
        this.nextButton.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || this.maximumScroll() <= 2) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const visualDirection = event.key === 'ArrowRight' ? 1 : -1;
            this.move(visualDirection * this.direction());
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({
              left: event.key === 'Home' ? 0 : this.maximumScroll() * this.direction(),
              behavior: this.scrollBehavior()
            });
          }
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      direction() {
        return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      }

      maximumScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      scrollBehavior() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      move(direction) {
        const item = this.track.querySelector('.miscella-blooms-gallery__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: step * direction * this.direction(), behavior: this.scrollBehavior() });
      }

      updateControls() {
        const maximum = this.maximumScroll();
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum <= 2;
        this.previousButton.disabled = position <= 1;
        this.nextButton.disabled = position >= maximum - 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
